import clsx from 'clsx';
import styles from './SourceBadge.module.scss';

interface SourceBadgeProps {
    value: string;
    className?: string;
}

const SourceBadge = ({ value, className }: SourceBadgeProps) => (
    <div className={clsx(styles.SourceBadge, className)}>
        <span className={styles.SourceBadgeLabel}>Source:</span>
        <span className={styles.SourceBadgeValue}>{value}</span>
    </div>
);

export default SourceBadge;
